import { Component, OnInit } from '@angular/core';
import { AddUser, LoginUser } from '../../_models';
import { AdminService } from '../../_services/admin.service';
import { ConfirmationDialogService } from '../../_services/confirmation-dialog.service';
import { GlobalDataService } from '../../_shared';
import { AutoCompleteService, UserService } from '../../_services';

import { Observable, Subject } from 'rxjs';
import {
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap
} from "rxjs/operators";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';
import { environment } from '../../../environments/environment';
@Component({
  standalone: false,
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {

 results!: Observable<AddUser[]>;  
private searchTerms = new Subject<string>();  
 loading: boolean = true;

config: any;
  addUser = new AddUser();
  viewUsers: AddUser[] = [];
  ABNumber=0;
  Name = '';  
  ProvisioningID = '';  
  Role='';
  SelectedRole='';
  Email='';
  IsEdit=false;
  CreatedDate ? : Date;
  CreatedBy='';
  SaveUpdate='Create User';
  now = new Date();
  user: LoginUser = new LoginUser;
  viewSasbuUsers: any[] = [];
  arrayList: Array<string> = [];
  constructor(
    private adminService  : AdminService,
    private confirmationDialogService: ConfirmationDialogService,
    private gd : GlobalDataService,
    private autoCompleteService  : AutoCompleteService,
    private modalService: NgbModal,
    private userService : UserService,
  ) {

   
   }

  AccessRole: Array<any> = [{Id:1,Name:"Admin"},{Id:2,Name:"EndUser"},{Id:2,Name:"ReadOnly"}]

  ngOnInit() {
    this.getAllSasbuUsers();
    this.getAllUsers();
    this.initForm();
    this.user = this.gd.getUserData();
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.viewUsers.length
    };
  }
Selected()
{
}
PrepareData(){
 //prepare json data
 if(this.isDefined(this.ProvisioningID))
 {
   this.addUser.ABNumber = this.ABNumber;
   this.addUser.Name = this.Name;
   this.addUser.Role = this.Role;
   this.addUser.ProvisioningID = this.ProvisioningID;
   this.addUser.Email = this.Email;
   this.addUser.IsActive = true;
   
   if(this.IsEdit==true){
    this.addUser.UpdatedBy=this.user.ProvisioningID;
    this.addUser.UpdatedDate=this.now;
   }
   else{
    this.addUser.CreatedBy=this.user.ProvisioningID;
    this.addUser.CreatedDate=this.now;
   }
 }
}
  OnSubmit(){

    this.PrepareData();
   this.adminService.addUser(this.addUser).subscribe({
    next: () => {
      this.getAllUsers();
      this.openAlertModal("Record Saved Successfully")
    },

    error: (err: any) => {  },
    complete: () => { }
  });
    
   
  }

  openAlertModal(strmsg: string) {
    const options ={
      backdrop: false,
      size: 'lg',
      keyboard : false

    };
    const modalRef = this.modalService.open(ModalPopupAlertComponent,options);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }

  public deleteConfirm(deleteUser : AddUser) {
    this.confirmationDialogService.confirm('Please confirm..', 'Do you really want to Delete. ?')
    .then((confirmed: boolean) => {if(confirmed==true){this.deleteUser(deleteUser)}})
    .catch(() => {});
  }
  deleteUser(deleteUser : AddUser) {
    deleteUser.IsActive=false;
    this.adminService.deleteUser(deleteUser).subscribe((res: any) => {
      this.getAllUsers();
    });
  }
  editUser(editUser : AddUser) {
    this.IsEdit=true;
    this.ABNumber = editUser.ABNumber;
    this.CreatedBy = editUser.CreatedBy;
    this.CreatedDate = editUser.CreatedDate;
    this.ProvisioningID = editUser.ProvisioningID;
    this.Name = editUser.Name;
    this.Email = editUser.Email;
    this.Role = editUser.Role;
    this.AccessRole.filter((value)=>{value ===editUser.Role });
    this.SaveUpdate="Update User";
    
  }
  getAllUsers()
  {
    this.adminService.viewUsers().subscribe((data: AddUser[])=>{
      this.viewUsers = data;
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.viewUsers.length
    };
   
    });
  }
  initForm()
  {
    this.Name = '';  
    this.ProvisioningID = '';  
    this.Role='';
    this.Email='';
    this.IsEdit=false;
    this.SaveUpdate="Create User";
    this.ABNumber=0;
  }

  initalCallService(){
    
    this.autoCompleteService.endPoint= environment.ApiUrl + "user/getuserlist/term";
    this.results = this.searchTerms.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(_ => (this.loading = true)),
      switchMap(term => this.autoCompleteService.search(term))
    );
    
  }


  getAllSasbuUsers()
  {
    this.userService.getSasbuUserList().subscribe((data: any[])=>{
      this.viewSasbuUsers = data;
      this.arrayList = data.map((user: { ProvisioningID: string; }) => user.ProvisioningID?.trim()); 
    });
  }

  searchUserProvisioningID= (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.arrayList.filter(v => v?.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  selectedItem(item: { item: string; }){
   let count= this.viewUsers.filter(t=>t.ProvisioningID?.toUpperCase().trim() ==item.item.toUpperCase().trim()).length;
     if(count >0){
      this.openAlertModal("User Already Present.");
      this.ProvisioningID ='';
      return;
     }
        this.Name = this.viewSasbuUsers.filter(t=>t.ProvisioningID ==item.item)[0].Name;
       this.Email =this.viewSasbuUsers.filter(t=>t.ProvisioningID ==item.item)[0].Email;
       
        this.loading = false;  
  }

  pageChanged(event: any){
    this.config.currentPage = event;
  }

  isDefined(value:any) {return typeof value !== 'undefined';}

}
